<template>
  <div class="notes">
    <div class="notes-topbar">
      <div class="notes-topbar__bioconnect">
        <a
          target="_blank"
          href="https://www.bioconnect.com"
        >
          <img src="../../assets/logos/bioconnect_dark.svg" />
        </a>
        Enabling Trust in the Connected World
      </div>
      <router-link
        id="sign-in"
        :to="{ name: 'login' }"
        class="notes-topbar__signin"
      >
        Sign In
        <span
          id="sign-in-icon"
          v-html="arrowIcon"
        />
      </router-link>
    </div>
    <div class="notes-page">
      <img
        class="notes__logo"
        src="../../assets/logos/link_logo_dark.svg"
      />
      <div class="notes__title">
        Release Notes
      </div>
      <template v-for="release in releasesContent">
        <article
          :key="release.version"
          class="notes-post"
        >
          <div class="notes-post-header">
            <div class="notes-post-header__version">
              {{ release.version }}
            </div>
            <div class="notes-post-header__date">
              {{ release.date }}
            </div>
          </div>
          <template v-if="release.added">
            <div class="notes-post-content">
              <div class="notes-post-content__title">
                Added
              </div>
              <div
                class="notes-post-content__list"
                v-html="markdownToHtml(release.added)"
              ></div>
            </div>
          </template>
          <template v-if="release.fixed">
            <div class="notes-post-content">
              <div class="notes-post-content__title">
                Fixed
              </div>
              <div
                class="notes-post-content__list"
                v-html="markdownToHtml(release.fixed)"
              ></div>
            </div>
          </template>
          <template v-if="release.improved">
            <div class="notes-post-content">
              <div class="notes-post-content__title">
                Improved
              </div>
              <div
                class="notes-post-content__list"
                v-html="markdownToHtml(release.improved)"
              ></div>
            </div>
          </template>
        </article>
      </template>
      <div class="notes-version">
        Current Build: {{ getBuildNumber() }}
      </div>
    </div>
  </div>
</template>

<script>
import {ENV} from '../../config'
import releaseNotesContent from '@/mixins/releaseNotes.js'
import feather from 'feather-icons'
import {marked} from 'marked'

export default {
  name: 'ReleaseNotes',
  mixins: [releaseNotesContent],
  data() {
    return {
      arrowIcon: feather.icons['arrow-right'].toSvg({width: '1.2em'}),
    }
  },
  methods: {
    getBuildNumber() {
      return ENV.buildNumber
    },
    markdownToHtml(content) {
      return marked(content)
    },
  },
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");
.notes {
  @include flex-display();
  @include flex-direction(column);
  font-family: "Montserrat";
  color: $black;
  height: auto;
  width: 100%;
  background-color: $off-white;
  box-sizing: border-box;
  &-topbar {
    @include flex-display();
    @include flex-justify-content(space-between);
    width: 100%;
    padding: 2em;
    box-sizing: border-box;
    &__bioconnect {
      @include flex-display();
      @include flex-direction(column);
      color: $black;
      font-size: $small-font;
      img {
        margin-bottom: 0.5em;
        width: 175px;
      }
    }
    &__signin {
      @include flex-display();
      @include flex-align-items(center);
      margin-right: 1em;
      #sign-in-icon {
        transition: transform 0.2s ease-out;
      }
      &:hover {
        #sign-in-icon {
          transform: translateX(0.5em);
        }
      }
    }
  }
  &-version {
    padding: 1em 0;
    color: $grey-text;
    font-weight: 600;
    font-size: $small-font;
  }
  &__logo {
    width: 150px;
  }
  &__title {
    margin-top: 1em;
    font-size: 2em;
  }
  &-page {
    @include flex-display();
    @include flex-align-items(center);
    @include flex-direction(column);
    padding: 2em;
  }
  &-post {
    background: $white;
    width: 75%;
    margin-top: 3em;
    padding: 1.5em;
    border-radius: 5px;
    box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    @media #{$large-display} {
      width: 50%;
    }
    &-header {
      @include flex-display();
      @include flex-justify-content(space-between);
      @include flex-align-items(center);
      padding-bottom: 1em;
      border-bottom: 1px solid $off-white;
      &__version {
        font-size: $title-font;
      }
      &__date {
        color: $grey-text;
      }
    }
    &-content {
      @include flex-display();
      @include flex-align-items(flex-start);
      padding: 2em;
      border-bottom: 1px solid $off-white;
      &:last-child {
        border-bottom: none;
      }
      &__title {
        color: $grey-text;
        width: 20%;
      }
      &__list {
        list-style-type: circle;
        width: 80%;
      }
    }
  }
}
</style>
